import { Routes } from '@angular/router';
import { AuthGuard } from '@auth0/auth0-angular';
import { WebhooksComponent } from './webhooks.component';

export const webhookRoutes: Routes = [
  { path: 'webhooks/:contextId/:contextIdType', component: WebhooksComponent, canActivate: [AuthGuard] }
];
